import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { EventsModel } from '@app/events/events-edit-form/events.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgForm, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DataArrayService } from '../events.service';
import { FormControl, Validators } from '@angular/forms';
import { DataStorageService } from '@app/shared/services/data-storage.service';
import { ApiService, AuthenticationService } from '@app/shared/services';
import { ImageService } from '@app/shared/services/image.service';
import esJson from '../../../assets/i18n/es.json';
import enJson from '../../../assets/i18n/en.json';
import { ConfirmationDialogComponent } from '@app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { NgxImageCompressService } from 'ngx-image-compress';

@Component({
  selector: 'app-events-edit-form',
  templateUrl: './events-edit-form.component.html',
  styleUrls: ['./events-edit-form.component.scss'],
  standalone: false
})
export class EventsEditFormComponent implements OnInit {

  langJson = (localStorage.getItem('lang') === 'es') ? esJson : enJson;

  @Output() newItem = new EventEmitter<EventsModel>();

  showAlert = false;
  alertMessage = '';
  alertType: 'success' | 'error' | 'info' | 'warn' = 'info';

  private showBottomAlert(
    message: string,
    type: 'success' | 'error' | 'info' | 'warn' = 'info',
    duration: number = 3000
  ) {
    this.alertMessage = message;
    this.alertType = type;
    this.showAlert = true;

    if (duration > 0) {
      setTimeout(() => {
        this.showAlert = false;
      }, duration);
    }
  }

  nuevoItem: any = {
    id: '',
    name: '',
    price: null,
    amount: null,
    minTickets: null,
    maxTickets: null,
    maxPerUser: null,
    description: '',
    location: '',
    iniDate: '',
    endDate: '',
    iniSale: '',
    endSale: '',
    categories: null
  };

  imagePath: any;
  resized: any;
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  imgURL: any;
  public message: string;
  files: any;
  fileUp: UntypedFormGroup;
  messageError: string;
  loadingFile: boolean;
  imageFileCompress: any;
  imageError: string;

  // Formulario dinámico
  isNominative: boolean = false;
  formData: any[] = [];
  editingFieldIndex: number = -1;
  fieldTypes: string[] = ['text', 'email', 'number', 'tel', 'date', 'textarea', 'select'];

  eventUserCategories: any[] = [];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EventsEditFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data_form: any,
    private dataArrayService: DataArrayService,
    public dataStorageService: DataStorageService,
    public imageService: ImageService,
    private imageCompress: NgxImageCompressService,
    private apiService: ApiService,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService
  ) {
    this.fileUp = new UntypedFormGroup({
      image: new UntypedFormControl(null)
    });
  }

  ngOnInit(): void {
    this.dataStorageService.fetchEventUserCategories().subscribe(response => {
      this.eventUserCategories = response.categories;
    });

    const eventClicked = this.dataArrayService.getEventClicked();
    this.nuevoItem.id = eventClicked?.id || '';
    this.nuevoItem.name = eventClicked?.name || '';
    this.nuevoItem.price = Number(eventClicked?.price) || 0;
    this.nuevoItem.amount = eventClicked?.amount || null;
    this.nuevoItem.minTickets = eventClicked?.minTickets || null;
    this.nuevoItem.maxTickets = eventClicked?.maxTickets || null;
    this.nuevoItem.maxPerUser = eventClicked?.maxPerUser || null;
    this.nuevoItem.description = eventClicked?.description || '';
    this.nuevoItem.location = eventClicked?.location || '';
    this.nuevoItem.iniDate = eventClicked?.iniDate.substring(0, 16) || '';
    this.nuevoItem.endDate = eventClicked?.endDate.substring(0, 16) || '';
    this.nuevoItem.iniSale = eventClicked?.iniSale.substring(0, 16) || '';
    this.nuevoItem.endSale = eventClicked?.endSale.substring(0, 16) || '';
    this.imgURL = eventClicked?.imageUrl || '';
    this.isNominative = eventClicked?.isNominative || false;

    if (eventClicked?.categories) {
      this.nuevoItem.categories = typeof eventClicked.categories === 'string'
        ? JSON.parse(eventClicked.categories)
        : eventClicked.categories;
    } else {
      this.nuevoItem.categories = null;
    }

    if (eventClicked?.formData) {
      try {
        if (typeof eventClicked.formData === 'string') {
          this.formData = JSON.parse(eventClicked.formData);
        } else if (Array.isArray(eventClicked.formData)) {
          this.formData = eventClicked.formData;
        } else {
          this.formData = [];
        }
      } catch (e) {
        console.error('Error al parsear formData:', e);
        this.formData = [];
      }
    } else {
      this.formData = [];
    }
  }

  preview(event: any) {
    if (event.target.files.length > 0) {
      let fileName: any;
      this.files = event.target.files[0];
      fileName = this.files['name'];
      const reader = new FileReader();
      reader.readAsDataURL(this.files);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
        this.compressFile(this.imgURL, fileName);
      };
    }
  }

  dataURItoBlob(dataURI: string) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([int8Array], { type: 'image/jpeg' });
  }

  compressFile(image: string, fileName: string) {
    const orientation = -1;
    this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
    this.imageCompress.compressFile(image, orientation, 50, 50).then(
      result => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
        const imageName = fileName;
        const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
        this.imageFileCompress = new File([result], imageName, { type: 'image/jpeg' });
      });
  }

  onSubmit(form: NgForm) {
    this.authenticationService.setLoader(true);
    if (!form.valid) {
      return;
    }

    this.dataArrayService.delete_event_state = 'actualizar_evento';
    this.dataArrayService.setDeleteEventState(false);
    const id = this.nuevoItem.id;
    const name = form.value.name?.trim() || '';
    const price = form.value.price ? Number(form.value.price) : 0;
    const amount = form.value.amount ? Number(form.value.amount) : null;
    const minTickets = form.value.minTickets ? Number(form.value.minTickets) : null;
    const maxTickets = form.value.maxTickets ? Number(form.value.maxTickets) : null;
    const maxPerUser = form.value.maxPerUser ? Number(form.value.maxPerUser) : null;
    const description = form.value.description?.trim() || '';
    const location = form.value.location?.trim() || '';
    const iniDate = form.value.iniDate || '';
    const endDate = form.value.endDate || '';
    const iniSale = form.value.iniSale || '';
    const endSale = form.value.endSale || '';
    const categories = form.value.categories || null;
    let nuevoDato: UntypedFormGroup = this.formBuilder.group({
      name: [name],
      price: [price],
      amount: [amount],
      minTickets: [minTickets],
      maxTickets: [maxTickets],
      maxPerUser: [maxPerUser],
      description: [description],
      location: [location],
      iniDate: [iniDate],
      endDate: [endDate],
      iniSale: [iniSale],
      endSale: [endSale],
      isNominative: [this.isNominative],
      formData: [this.formData],
      categories: [categories]
    });

    // Filtrar campos vacíos
    const keys = Object.keys(nuevoDato.value);
    const keysFiltradas = keys.filter(
      key =>
        nuevoDato.value[key] !== null &&
        nuevoDato.value[key] !== '' &&
        nuevoDato.value[key] !== ''
    );

    if (nuevoDato.value.formData !== undefined) {
      nuevoDato.value.formData = JSON.stringify(nuevoDato.value.formData);
    }
    if (nuevoDato.value.categories !== undefined) {
      nuevoDato.value.categories = JSON.stringify(nuevoDato.value.categories);
    }

    const nuevoFormularioControls: any = {};
    keysFiltradas.forEach(key => {
      nuevoFormularioControls[key] = this.formBuilder.control(nuevoDato.value[key]);
    });

    const nuevoFormulario = this.formBuilder.group(nuevoFormularioControls);
    nuevoDato = nuevoFormulario;
    const updateData2 = new FormData();
    for (const key in nuevoDato.value) { // Agrega todos los campos al updateData (incluido el archivo)
      if (nuevoDato.value.hasOwnProperty(key)) {
        updateData2.append(key, nuevoDato.value[key]);
      }
    }

    if (this.files) {
      updateData2.append('image', this.files, this.imageFileCompress.name);
    }

    this.dataStorageService.updateTicketTypeWithAccount(updateData2, this.nuevoItem.id).subscribe({
      next: (data) => {
        this.dataArrayService.addData(data.data);
        this.dialogRef.close({ edited: true, data: data.data });
      },
      error: (err) => {
        console.error(err);
        this.dialogRef.close({
          edited: false,
          error: true,
          type: 'eventEditedError',
          errorMessage: this.langJson?.events?.editError || 'Ha ocurrido un error al actualizar el evento.'
        });
      }
    });
  }

  onDelete() {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: 'Va a eliminarse el evento. ¿Está seguro?',
      autoFocus: false
    });

    dialogRef2.afterClosed().subscribe(result => {
      if (result) {
        this.authenticationService.setLoader(true);
        this.dataArrayService.setDeleteEventState(true);
        this.dataStorageService.deleteTicketTypeWithAccount(this.nuevoItem.id).subscribe({
          next: (data) => {
            this.dataArrayService.setData(data);
            (this.nuevoItem as any).deleted = true;
            this.dialogRef.close(this.nuevoItem);
          },
          error: (err) => {
            console.error(err);
            this.dialogRef.close({
              deleted: false,
              error: true,
              type: 'eventDeletedError',
              errorMessage:
                err?.status === 0
                  ? 'No hay conexión a Internet. Revisa tu conexión e inténtalo de nuevo.'
                  : this.langJson?.events?.deleteError || 'Ha ocurrido un error al eliminar el evento.'
            });
          }
        });
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  // Validators
  name_control = new FormControl('', [Validators.required]);

  getErrorMessage_name() {
    if (this.name_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  price_control = new FormControl('', [Validators.required]);

  getErrorMessage_price() {
    if (this.price_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  amount_control = new FormControl('', [Validators.required]);

  getErrorMessage_amount() {
    if (this.amount_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  minTickets_control = new FormControl('', [Validators.required]);

  getErrorMessage_minTickets() {
    if (this.minTickets_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  maxTickets_control = new FormControl('', [Validators.required]);

  getErrorMessage_maxTickets() {
    if (this.maxTickets_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  maxPerUser_control = new FormControl('', [Validators.required]);

  getErrorMessage_maxPerUser() {
    if (this.maxPerUser_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  // Métodos para gestionar el formulario dinámico
  addFormField() {
    const newField: any = {
      name: '',
      type: 'text',
      webName: '',
      required: false
    };
    if (newField.type === 'select') {
      newField.options = [];
    }
    this.formData.push(newField);
    this.editingFieldIndex = this.formData.length - 1;
  }

  editFormField(index: number) {
    this.editingFieldIndex = index;
  }

  saveFormField(index: number) {
    const field = this.formData[index];

    if (!field.name || !field.webName) {
      this.showBottomAlert('El nombre y el nombre web son obligatorios', 'error');
      return;
    }

    if (!/^[a-zA-Z0-9_]+$/.test(field.name)) {
      this.showBottomAlert('El nombre solo puede contener letras, números y guiones bajos', 'error');
      return;
    }

    const duplicateIndex = this.formData.findIndex((f, i) => i !== index && f.name === field.name);
    if (duplicateIndex !== -1) {
      this.showBottomAlert('Ya existe un campo con ese nombre', 'error');
      return;
    }

    if (field.type === 'select') {
      if (!field.options || field.options.length === 0) {
        this.showBottomAlert('Los campos de tipo select deben tener al menos una opción', 'error');
        return;
      }

      const invalidOption = field.options.find((opt: any) => !opt.name || opt.name.trim() === '');
      if (invalidOption) {
        this.showBottomAlert('Todas las opciones deben tener un nombre', 'error');
        return;
      }
    } else {
      delete field.options;
    }

    this.editingFieldIndex = -1;
  }

  cancelEditFormField() {
    const index = this.editingFieldIndex;
    if (index >= 0 && (!this.formData[index].name || !this.formData[index].webName)) {
      this.formData.splice(index, 1);
    }
    this.editingFieldIndex = -1;
  }

  deleteFormField(index: number) {
    this.formData.splice(index, 1);
    if (this.editingFieldIndex === index) {
      this.editingFieldIndex = -1;
    } else if (this.editingFieldIndex > index) {
      this.editingFieldIndex--;
    }
  }

  isEditingField(index: number): boolean {
    return this.editingFieldIndex === index;
  }

  onFieldTypeChange(index: number) {
    const field = this.formData[index];
    if (field.type === 'select') {
      if (!field.options) {
        field.options = [];
      }
    } else {
      delete field.options;
    }
  }

  addOption(fieldIndex: number) {
    const field = this.formData[fieldIndex];
    if (!field.options) {
      field.options = [];
    }
    field.options.push({ name: '' });
  }

  removeOption(fieldIndex: number, optionIndex: number) {
    const field = this.formData[fieldIndex];
    if (field.options && field.options.length > optionIndex) {
      field.options.splice(optionIndex, 1);
    }
  }

  hasOptions(fieldIndex: number): boolean {
    const field = this.formData[fieldIndex];
    return field.type === 'select' && field.options && field.options.length > 0;
  }
}
